import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';
import { PrincipalLayoutComponent } from './layouts/principal-layout/principal-layout.component';
import { AuthGuard } from './_helpers/auth.guard';
import { SpasswordComponent } from './principal/spassword/spassword.component';

const routes: Routes = [
  { path: 'login', redirectTo: 'login', pathMatch: 'full' },
  { path: 'spassword', component: SpasswordComponent },
  {
      path: '',
      component: UserLayoutComponent,
      // canLoad: [AuthGuard],
      canActivate: [AuthGuard],
      children: [
        {
          path: '',
          loadChildren: () => import('./user/user.module').then(m => m.UserModule)
        }
      ]
  }, {
      path: '',
      component: PrincipalLayoutComponent,
      children: [
        {
          path: '',
          loadChildren: () => import('./principal/principal.module').then(m => m.PrincipalModule)
        },
      ]
  }, {
      path: '**',
      redirectTo: 'index'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
